<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row justify="end" align="center" class="mb-4">
          <v-col cols="12" md="4">
            <v-text-field
              class="ui-form-field"
              v-model="buscarTexto"
              color="secondary"
              background-color="transparent"
              rounded
              filled
              placeholder="Buscar"
              append-icon="mdi-magnify"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <v-card class="ui-module-card" color="primary">
          <v-card-text class="pa-0">
            <v-data-table
              class="primary"
              :headers="headers"
              :items="locs"
              :search="buscarTexto"
              :items-per-page="15"
              :footer-props="{
                'items-per-page-options': [10, 15, 25, 50, 100],
              }"
              :loading="loading"
            >
              <template v-slot:[`item.activo`]="{ item }">
                <v-chip :color="item.activo ? 'success' : 'error'" dark small>
                  {{ item.activo ? 'Activo' : 'Inactivo' }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    idArma: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        { text: 'No. Licencia', value: 'noLicencia', width: '120px', align: 'left' },
        { text: 'Fecha Alta', value: 'fechaAlta', width: '150px', align: 'left' },
        { text: 'RM', value: 'rm', width: '120px', align: 'left' },
        { text: 'ZM', value: 'zm', width: '120px', align: 'left' },
        { text: 'Instancia', value: 'nombre_instancia', width: '250px', align: 'left' },
        { text: 'Titular', value: 'titular', width: '300px', align: 'left' },
        { text: 'Representante Legal', value: 'representanteLegal', width: '300px', align: 'left' },
        { text: 'Dirección', value: 'direccion', width: '250px', align: 'left' },
        { text: 'Fecha Trámite', value: 'fechaTramite', width: '150px', align: 'left' },
        { text: 'Vigencia', value: 'vigencia', width: '100px', align: 'left' },
        { text: 'Estatus', value: 'activo', width: '100px', sortable: false },
      ],
      buscarTexto: '',
      loading: false,
    }
  },

  computed: {
    ...mapGetters('armeria', {
      historialArma: 'getHistorial',
    }),

    locs() {
      if (!this.historialArma || this.historialArma.length === 0) return []

      // Extraer todos los LOCs del historial
      const locsList = []
      this.historialArma.forEach((arma) => {
        if (arma.lOCS && arma.lOCS.length > 0) {
          arma.lOCS.forEach((loc) => {
            locsList.push(loc)
          })
        }
      })

      return locsList
    },
  },
}
</script>

<style scoped>
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table-header {
  background: rgba(108, 92, 231, 0.15) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid rgba(108, 92, 231, 0.3) !important;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(108, 92, 231, 0.2) !important;
  color: #e0e0e0 !important;
}
</style>
